// Vencimentos das parcelas do acordo (pedido da Aline em 24/10/2026: com periodicidade de 30 dias o 1º vencimento em 30/10
// gerava 29/11, 29/12, 28/01... e parcelas caíam no mesmo mês). Periodicidade mensal (28 a 31 dias) = o mesmo dia do mês
// do vencimento de referência; no mês que não tem esse dia (31 em abril, 29-31 em fevereiro), o último dia do mês. Outra
// periodicidade (ex.: 7, 15) = a cada N dias. Caindo num domingo, a parcela vai para a segunda (no último dia do mês, para o
// sábado, para não cair no mês seguinte); só o domingo é pulado.
// Cada data sai da referência (não da parcela anterior), então o dia não "escorrega" depois de um mês curto ou de um domingo.
import moment from "moment";

export const ehPeriodicidadeMensal = (periodicidade) => {
    const dias = Number(periodicidade) || 30;
    return dias >= 28 && dias <= 31;
};

/**
 * Pula o domingo: domingo vira a segunda seguinte. Se a segunda já é do mês seguinte (domingo no último dia do mês, ex.:
 * 28/02/2027), fica o sábado anterior, senão o mês seguinte teria duas parcelas.
 */
export const semDomingo = (data) => {
    const d = moment(data);
    if (d.day() !== 0) return d;
    const segunda = d.clone().add(1, "day");
    return segunda.month() === d.month() ? segunda : d.clone().subtract(1, "day");
};

/**
 * Vencimento da parcela de índice `indice` (0 = a própria referência, que fica como foi informada) a partir de
 * `referencia` (YYYY-MM-DD ou moment), na periodicidade em dias.
 */
export const vencimentoDaParcela = (referencia, indice, periodicidade) => {
    const base = moment(referencia);
    if (indice <= 0) return base;
    const data = ehPeriodicidadeMensal(periodicidade)
        ? base.clone().add(indice, "months")
        : base.clone().add(indice * (Number(periodicidade) || 30), "days");
    return semDomingo(data);
};

/** As `quantidade` datas (YYYY-MM-DD) a partir da referência, a 1ª sendo a própria referência. */
export const vencimentosDasParcelas = (referencia, quantidade, periodicidade) =>
    Array.from({ length: Math.max(0, quantidade) }, (_, i) => vencimentoDaParcela(referencia, i, periodicidade).format("YYYY-MM-DD"));
